/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { ContentStackSegmentation } from '../../interface/content-types';

export type Segmentable = {
  segmentation: NonNullable<ContentStackSegmentation>;
};

export const isSegmentation = (item: unknown): item is NonNullable<Segmentable['segmentation']> => {
  if (!item) {
    return false;
  }

  return Boolean(typeof item === 'object' && 'segment' in item && Array.isArray(item.segment));
};
